import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import H1 from '@base/H1/H1';
import P1 from '@base/P1/P1';
import Paper from '@base/Paper/Paper';
import CircularLoader from '@base/CircularLoader/CircularLoader';
import YouTube from '@cont/FreeLesson/externalyoutube';
import { getisLoading, getCMSDataDescription } from '@selectors/careers';

const Wrapper = styled(Paper)`
  grid-column: span 24;
  padding: ${Spacings.SPACING_0B};
  padding-top: 116px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;

  ${mediaQuery.uptoTablet} {
    padding: ${Spacings.SPACING_15B} ${Spacings.SPACING_4B};
  }
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_15B} ${Spacings.SPACING_4B};
  }
`;

const Header = styled(H1)`
  text-align: center;
  font-size: 40px;
  line-height: 120%;
  margin-bottom: ${Spacings.SPACING_2B};

  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H4};
  }
`;
const SubText = styled(P1)`
  text-align: center;
  font-size: ${Fonts.H3};
  margin-bottom: ${Spacings.SPACING_16B};
  width: 751px;

  ${mediaQuery.uptoMobile} {
    width: 322px;
    margin-bottom: ${Spacings.SPACING_8B};
    font-size: ${Fonts.H6};
  }
`;
const VideoWrapper = styled.div`
  margin: auto;
  padding: ${Spacings.SPACING_0B} 116px;
  margin-bottom: 116px;
  width: 100%;
  height: 627px;

  ${mediaQuery.uptoTablet} {
    padding: ${Spacings.SPACING_0B};
    margin: ${Spacings.SPACING_0B};
    width: 80%;
    height: 433px;
  }
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_0B};
    margin: ${Spacings.SPACING_0B};
    width: 328px;
    height: 240px;
  }
`;

const YoutubeVideo = () => {
  const cmsData = useSelector(getCMSDataDescription);
  const isLoadingState = useSelector(getisLoading);
  const [videoId, setVideoid] = useState('');

  useEffect(() => {
    if (cmsData.length > 0) setVideoid(JSON.parse(cmsData).mainVideo);
  }, [cmsData]);

  const opts = {
    height: '100%',
    width: '100%',
    playerVars: {
      autoplay: 0,
      showinfo: 0,
      rel: 0
    }
  };

  if (videoId.length > 0)
    return (
      <Wrapper>
        {isLoadingState ? (
          <CircularLoader />
        ) : (
          <>
            <Header>Are you a believer?</Header>
            <SubText>
              If you resonate with our mission, then come join us. Together, we
              can build the world’s best consumer internet product.
            </SubText>
            <VideoWrapper>
              {videoId.length > 0 && <YouTube videoId={videoId} opts={opts} />}
            </VideoWrapper>
          </>
        )}
      </Wrapper>
    );
  return null;
};

export default YoutubeVideo;
